import { array, mixed, object, string } from 'yup';
import type { SchemaOf } from 'yup';

import type { NodeViewModel } from '@/docker/models/node';

import type { DockerNetwork } from '../../types';

import type { MacvlanFormValues } from './types';

export function macvlanFormValidation(): SchemaOf<MacvlanFormValues> {
  return object({
    scope: mixed<'local' | 'swarm'>()
      .oneOf(['local', 'swarm'] as const)
      .required('Scope is required'),

    parentNetworkCard: string()
      .default('')
      .when('scope', {
        is: 'local',
        then: (schema) =>
          schema
            .trim()
            .min(1, 'Parent network card cannot be blank')
            .required('Parent network card is required'),
        otherwise: (schema) => schema.optional(),
      }),

    selectedNetworkConfig: mixed<DockerNetwork>()
      .nullable()
      .default(null)
      .when('scope', {
        is: 'swarm',
        then: (schema) =>
          schema
            .nullable()
            .required('A configuration network must be selected'),
        otherwise: (schema) => schema.nullable().optional(),
      }),

    selectedNodes: array<NodeViewModel>().default([]),
    // TODO: this can be properly typed when all uses of `NodeViewModel` are converted to React and use a Typescript interface
  }) as unknown as SchemaOf<MacvlanFormValues>;
}
